export type ColorOption = {
  label: string;
  hex: string;
  group: string;
};

/**
 * Color Palette Map
 *
 * This map contains all the colors that can be used in the color picker.
 * It is used to populate the color picker dropdown with the colors from the Figma file.
 * https://www.figma.com/design/KjxX2VgOwTHFtracJBDW1x/24Q2-LPC-2.0-Optimization?node-id=193-429&m=dev
 */
export const COLORS: ColorOption[] = [
  { label: 'None', hex: '', group: '' },
  { label: 'Hexcolor', hex: 'HEXCOLOR', group: 'Hexcolor' },
  // Blue
  { label: 'Blue 700', hex: '#02143A', group: 'Blue' },
  { label: 'Blue 600', hex: '#02427E', group: 'Blue' },
  { label: 'Blue 500', hex: '#005FB9', group: 'Blue' },
  { label: 'Blue 400', hex: '#4B99E6', group: 'Blue' },
  { label: 'Blue 300', hex: '#9DCDF4', group: 'Blue' },
  { label: 'Blue 200', hex: '#C8E4FE', group: 'Blue' },
  { label: 'Blue 100', hex: '#DEEFFf', group: 'Blue' },
  { label: 'Blue 50', hex: '#EEF7FF', group: 'Blue' },

  // Green
  { label: 'Green 700', hex: '#00482F', group: 'Green' },
  { label: 'Green 600', hex: '#006642', group: 'Green' },
  { label: 'Green 500', hex: '#008254', group: 'Green' },
  { label: 'Green 400', hex: '#40A087', group: 'Green' },
  { label: 'Green 300', hex: '#81D6B8', group: 'Green' },
  { label: 'Green 200', hex: '#B7ECDA', group: 'Green' },
  { label: 'Green 100', hex: '#E3FAF2', group: 'Green' },
  { label: 'Green 50', hex: '#EFFCF8', group: 'Green' },

  // Yellow
  { label: 'Yellow 700', hex: '#B07000', group: 'Yellow' },
  { label: 'Yellow 600', hex: '#EFA92E', group: 'Yellow' },
  { label: 'Yellow 500', hex: '#FFC764', group: 'Yellow' },
  { label: 'Yellow 400', hex: '#FBD083', group: 'Yellow' },
  { label: 'Yellow 300', hex: '#FFE2AE', group: 'Yellow' },
  { label: 'Yellow 200', hex: '#FFF0D6', group: 'Yellow' },
  { label: 'Yellow 100', hex: '#FFFFEA', group: 'Yellow' },
  { label: 'Yellow 50', hex: '#FFFFF4', group: 'Yellow' },

  // Red
  { label: 'Red 700', hex: '#7A0000', group: 'Red' },
  { label: 'Red 600', hex: '#B40000', group: 'Red' },
  { label: 'Red 500', hex: '#DE2828', group: 'Red' },
  { label: 'Red 400', hex: '#FF5D5E', group: 'Red' },
  { label: 'Red 300', hex: '#FF9090', group: 'Red' },
  { label: 'Red 200', hex: '#FFBFBF', group: 'Red' },
  { label: 'Red 100', hex: '#FFE8E8', group: 'Red' },
  { label: 'Red 50', hex: '#FFFFF7', group: 'Red' },

  // Brown
  { label: 'Brown 700', hex: '#652812', group: 'Brown' },
  { label: 'Brown 600', hex: '#91472B', group: 'Brown' },
  { label: 'Brown 500', hex: '#B96C4F', group: 'Brown' },
  { label: 'Brown 400', hex: '#D58B70', group: 'Brown' },
  { label: 'Brown 300', hex: '#EDBEAD', group: 'Brown' },
  { label: 'Brown 200', hex: '#FFAEA2', group: 'Brown' },
  { label: 'Brown 100', hex: '#FEF4F1', group: 'Brown' },
  { label: 'Brown 50', hex: '#FFFAF9', group: 'Brown' },

  // Neutral
  { label: 'Neutral 900', hex: '#000000', group: 'Neutral' },
  { label: 'Neutral 800', hex: '#3D4045', group: 'Neutral' },
  { label: 'Neutral 700', hex: '#64666A', group: 'Neutral' },
  { label: 'Neutral 600', hex: '#8B8C8F', group: 'Neutral' },
  { label: 'Neutral 500', hex: '#B1B3B5', group: 'Neutral' },
  { label: 'Neutral 400', hex: '#D8D9DA', group: 'Neutral' },
  { label: 'Neutral 300', hex: '#EBEBEC', group: 'Neutral' },
  { label: 'Neutral 200', hex: '#F7F7F7', group: 'Neutral' },
  { label: 'Neutral 100', hex: '#FFFFFF', group: 'Neutral' },

  // NW Logo Green
  { label: 'NW Logo Green 700', hex: '#00682C', group: 'NW Logo Green' },
  { label: 'NW Logo Green 500', hex: '#00AE4D', group: 'NW Logo Green' },
  { label: 'NW Logo Green 300', hex: '#8DC53F', group: 'NW Logo Green' },

  // Highlight Accent Color
  { label: 'Bone', hex: '#F4EEE6', group: 'Highlight Accent' },
  { label: 'Pineapple', hex: '#FFFF66', group: 'Highlight Accent' },
  { label: 'Lime', hex: '#E2FF39', group: 'Highlight Accent' },
  { label: 'Lilac', hex: '#EBD5EF', group: 'Highlight Accent' },
  { label: 'Pink', hex: '#FF97E9', group: 'Highlight Accent' },
  { label: 'Cobalt', hex: '#1900FF', group: 'Highlight Accent' },
];
